<template>
  <div class="batteries">
    <div class="leftbattery battery" v-if="leftController && leftController.battery" :title="Math.round(leftController.battery * 100) + '%'">
      <div class="label f8">{{ $t('L') }}</div>
      <div class="batterycontainer" :class="{ charging: leftController.charging, warning: leftController.battery <= 0.3, error: leftController.battery <= 0.1 }">
        <svg><use :xlink:href="(leftController.charging) ? '#icon-battery-charging' : '#icon-battery'"></use></svg>
        <div class="fill" :style="{ transform: 'scaleX(' + leftController.battery + ')'}"></div>
      </div>
    </div>
    <div class="rightbattery battery" v-if="rightController && rightController.battery" :title="Math.round(rightController.battery * 100) + '%'">
      <div class="label f8">{{ $t('R') }}</div>
      <div class="batterycontainer" :class="{ charging: rightController.charging, warning: rightController.battery <= 0.3, error: rightController.battery <= 0.1 }">
        <svg><use :xlink:href="(rightController.charging) ? '#icon-battery-charging' : '#icon-battery'"></use></svg>
        <div class="fill" :style="{ transform: 'scaleX(' + rightController.battery + ')'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    leftController: {
      type: Object,
      required: false,
    },
    rightController: {
      type: Object,
      required: false,
    },
  },
})
export default class Batteries extends Vue {

}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.batteries {
  display: flex;

  & .battery {
    display: flex;
    align-items: center;
    margin-right: var(--spacingXS);

    &:last-child {
      margin-right: 0;
    }

    & .label {
      margin-right: 0.2rem;
      position: relative;
      font-size: 0.7rem;
      top: 0.1rem;
    }

    & .batterycontainer {
      position: relative;

      & svg {
        fill: var(--colorManatee);
        width: 2rem;
        height: 2rem;
      }

      & .fill {
        background-color: var(--colorManatee);
        position: absolute;
        top: 0.5rem;
        left: 0.1rem;
        width: 75%;
        height: 40%;
        transform-origin: left center;
      }

      &.warning {
        & svg { fill: var(--colorErrorFlat); }
        & .fill { background-color: var(--colorErrorFlat); }
      }

      &.error {
        & svg { fill: var(--colorError); }
        & .fill { background-color: var(--colorError); }
      }

      &.charging {
        & svg { fill: var(--colorSuccessFlat); }
        & .fill { opacity: 0.3; }
      }
    }
  }
}
</style>
